import Pricing from '../components/Pricing';

const PricingPage = () => {
  return (
    <div className="min-h-screen bg-slate-950 pt-16">
      <Pricing />
    </div>
  );
};

export default PricingPage;
